export { default as FileUpload } from './FileUpload.svelte'

import FilePondPluginFileRename from 'filepond-plugin-file-rename'
import { registerPlugin } from 'filepond'

// Register the plugin
registerPlugin(FilePondPluginFileRename);

